import ScrollReveal from "./ScrollReveal";

// PLACEHOLDER — replace `quote`, `name`, `title`, and `company` with real testimonials
// as they come in. Delete any entry that isn't sourced.
const testimonials = [
  {
    quote:
      "Rick is the rare operator who can look at both the security posture and the product roadmap in the same conversation, and give you a straight answer about what to do first.",
    name: "[Name]",
    title: "[Title]",
    company: "[Company]",
    placeholder: true,
  },
  {
    quote:
      "We hired Rick to run a Discovery Sprint. We came out with an MVP scope we actually trusted, a threat model, and a hiring plan. He gave us six months of clarity in three weeks.",
    name: "[Name]",
    title: "[Title]",
    company: "[Company]",
    placeholder: true,
  },
  {
    quote:
      "Most fractional CTOs are just contractors with a fancier title. Rick was a co-founder from day one — writing code, taking calls with enterprise buyers, and making the SOC 2 lift painless.",
    name: "[Name]",
    title: "[Title]",
    company: "[Company]",
    placeholder: true,
  },
];

const hasRealTestimonials = testimonials.some((t) => !t.placeholder);

export default function Testimonials() {
  // Don't render the section until at least one real testimonial exists.
  if (!hasRealTestimonials) return null;

  return (
    <section
      id="testimonials"
      aria-label="Testimonials"
      className="editorial-container section-spacing"
    >
      <hr className="editorial-rule mb-16 lg:mb-20" />

      <ScrollReveal>
        <p className="font-mono text-label uppercase tracking-[0.05em] text-accent">
          WHAT PEOPLE SAY
        </p>
      </ScrollReveal>

      <ScrollReveal stagger={1}>
        <h2 className="mt-6 max-w-3xl font-display text-section font-bold text-foreground md:text-section-md lg:text-section-lg">
          Real founders. Real outcomes.
        </h2>
      </ScrollReveal>

      <div className="mt-16 grid gap-8 md:grid-cols-3 md:gap-6">
        {testimonials
          .filter((t) => !t.placeholder)
          .map((t, i) => (
            <ScrollReveal
              key={i}
              stagger={Math.min(i + 1, 3) as 1 | 2 | 3}
            >
              <blockquote className="flex h-full flex-col border-t border-accent pt-6">
                <p className="text-body text-foreground-muted md:text-body-md">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <footer className="mt-6">
                  <p className="font-mono text-small uppercase tracking-[0.05em] text-accent">
                    {t.name}
                  </p>
                  <p className="mt-1 text-small text-foreground-faint">
                    {t.title} · {t.company}
                  </p>
                </footer>
              </blockquote>
            </ScrollReveal>
          ))}
      </div>
    </section>
  );
}
